import { Upload } from "../models";
import { isDevelopment } from "./isDevelopment";

export const GetImageForSize = (resource: Upload, size: 'thumbnail' | 'small' | 'medium' | 'large') => {
  return resource.formats[size] ? resource.formats[size].url : resource.url;
}

export const GetImgUrl = (url: string) => {
  if (isDevelopment()) {
    let prefix = process.env.NEXT_PUBLIC_IMAGE_PREFIX || process.env.NEXT_PUBLIC_API_URL.slice(0, -1);
    return prefix + url;
  }
  // In this case the url is from Cloudinary
  return url;
}